'use client'

import AgentPromoted from '@component/card/agent/promoted'
import Pagination from '@component/pagination'
import useFetch from '@hooks/useFetch'
import { map, size } from 'lodash-es'
import { useCallback, useState } from 'react'
import { SkeletonOfficeTeam } from './index'

export default function OfficeTeamContent({
  defaultData,
  id,
  pageIndex,
  pageSize,
  totals
}) {

  const [pageIdx, setPageIdx] = useState(pageIndex)
  const isDefault = pageIdx === pageIndex

  const { data, isLoading } = useFetch(isDefault ? null : { url: `office/${id}/agents`, params: { limit: pageSize, offset: (pageIdx - 1) * pageSize } })
  const viewData = isDefault ? defaultData : data

  const changeHandle = useCallback(idx => {
    setPageIdx(idx)
  }, [setPageIdx])

  return (
    <>
      {
        isLoading && (
          <SkeletonOfficeTeam></SkeletonOfficeTeam>
        )
      }
      {
        !isLoading && size(viewData) > 0 && (
          <div className='grid grid-cols-1 gap-16 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4'>
            {
              map(viewData, item => (
                <AgentPromoted data={item} key={item.id}></AgentPromoted>
              ))
            }
          </div>
        )
      }
      {
        totals > pageSize && (
          <Pagination pageIndex={pageIndex} right pageSize={pageSize} totals={totals} onChange={changeHandle} className='mt-20'></Pagination>
        )
      }
    </>
  )
}
